import React from "react";
import { colors, resolveColor } from "utils/styles";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Stack from "react-bootstrap/Stack";
export default function StatsSection(props) {
	const fields = props.data?.fields;

	const StatsItem = ({ number, text }) => {
		return (
			<Col xs={7} sm={5} md={4} lg={true} className="d-flex flex-column text-center  pe-3 pe-xl-5 py-4">
				<h3 className="number">{number}</h3>

				<p className="text">{text}</p>
				<style jsx="true">{`
					.number {
						color: ${resolveColor(fields?.numberColor) || colors.yellow};
						font-size: 40px;
						line-height: 42px;
						font-weight: bold;
						margin: 0;
					}

					.text {
						margin: 0;
						color: ${resolveColor(fields?.descriptionColor) || colors.white};
						font-weight: 600;
					}
				`}</style>
			</Col>
		);
	};

	const ColorBarItem = ({ color, text }) => {
		return (
			<Col xs={7} sm={5} md={4} lg={3} className="  ">
				<Row className="p-3">
					<Col xs={"auto"}>
						<div className="colorBar"></div>
					</Col>
					<Col>
						<p className="text">{text}</p>
					</Col>
				</Row>

				<style jsx="true">{`
					.colorBar {
						border-left: 1px solid ${colors[color]};
						height: 100%;
					}

					.text {
						margin: 0;
						color: ${resolveColor(fields?.descriptionColor) || colors.white};
						font-weight: 600;
					}
				`}</style>
			</Col>
		);
	};

	return (
		<Container fluid className="g-0 container-lg">
			<section className="py-4  quoteSection  moveUp">
				{/* Renders stats with number and description */}
				{fields?.statisticsList?.stats && (
					<Row className="g-0 ps-md-5 ps-lg-3 ps-xl-5 justify-content-center">
						{fields?.statisticsList?.stats.map((stat, index) => {
							return <StatsItem key={index} number={stat.number} text={stat.description} />;
						})}
					</Row>
				)}

				{/* Renders stats with color bar and content */}
				{fields?.statisticsList?.colorBars && (
					<Row className="g-0 p-2">
						{fields?.statisticsList?.colorBars.map((colorBar, index) => {
							return <ColorBarItem key={index} color={colorBar.color} text={colorBar.description} />;
						})}
					</Row>
				)}
			</section>
			<style jsx="true">{`
				.moveUp {
					margin-top: ${fields?.moveUp + "em" || "-10em"};
					z-index: 15;
					position: relative;
				}

				.quoteSection {
					background: ${resolveColor(fields?.backgroundColor)};
				}
			`}</style>
		</Container>
	);
}
